require("jquery-ui/ui/widgets/autocomplete.js");
var Genesis = require("../Genesis.js");

function GhostUserAutoComplete() {

    $(function () {
        console.log("GhostUserAutoComplete initialized");
        $("#userLookupSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                console.log("Searching for: " + request.term);
                $.ajax({
                    url: "GhostMode/GetGhostUserLookup",
                    type: "POST",
                    dataType: "json",
                    data: { searchTerm: request.term },
                    success: function (data) {
                        console.log(data);
                        response($.map(data, function (item) {
                            return { label: item.contact, value: item.userId, username: item.username };
                        }))
                    }
                })
            },
            select: function (event, ui) {

                $("#userLookupSearch").val(ui.item.label);
                $("#hdnGhostedUserId").val(ui.item.value);
                $("#hdnGhostedUserName").val(ui.item.username);
                $("#btn-Submit").prop("disabled", false);
                return false;
            }
        });
    });
}

module.exports = GhostUserAutoComplete;